// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button_button__phgUo","loading":"save-button_loading__R5361"};